export default __webpack_public_path__ + "static/media/whatsapp-icon.20d6fed0.svg";